import { Text, Flex, Spinner } from '@servicetitan/anvil2';

export interface StepItem {
    label: string;
    description: string;
    completed: boolean;
}

interface VerticalStepperProps {
    steps: StepItem[];
}

export const VerticalStepper = ({ steps }: VerticalStepperProps) => {
    return (
        <Flex direction="column" gap="3" style={{ width: '100%', maxWidth: '400px' }}>
            {steps.map((step, index) => (
                <Flex
                    key={step.label}
                    gap="3"
                    alignItems="flex-start"
                    style={{ position: 'relative' }}
                >
                    {/* Checkmark circle */}
                    <Flex
                        alignItems="center"
                        justifyContent="center"
                        shrink={0}
                        style={{
                            width: '18px',
                            height: '18px',
                            border: '1px solid #0265DC',
                            borderRadius: '50%',
                            backgroundColor: step.completed ? '#0265DC' : '#FFF',
                            color: 'white',
                            position: 'relative',
                            zIndex: 1,
                        }}
                    >
                        {step.completed ? (
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                                <path
                                    d="M1.5 5L4 7.5L8.5 3"
                                    stroke="white"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        ) : (
                            <Spinner style={{ width: '18px', height: '18px' }} />
                        )}
                    </Flex>

                    {/* Connecting line */}
                    {index < steps.length - 1 && (
                        <div
                            style={{
                                position: 'absolute',
                                left: '8px',
                                top: '18px',
                                width: '2px',
                                height: '70px',
                                backgroundColor: step.completed ? '#0265DC' : '#E0E0E0',
                            }}
                        />
                    )}

                    {/* Step content */}
                    <Flex direction="column" gap="1">
                        <Text variant="body" style={{ fontWeight: 600, margin: 0 }}>
                            {step.label}
                        </Text>
                        <Text
                            variant="body"
                            style={{ color: '#666', margin: 0, minHeight: '30px' }}
                        >
                            {step.description}
                        </Text>
                    </Flex>
                </Flex>
            ))}
        </Flex>
    );
};
